import { createSelector } from 'reselect';

import {
  // Frame
  hasUserSelector,
  // Navigation
  jobsFooterSelector,
  eventsFooterSelector,
  newsFooterSelector,
  groupsFooterSelector,
  companiesFooterSelector,
  campusFooterSelector,
  coachesFooterSelector,
  // Props
  localeSelector,
} from '../../selectors';
import { localizedLink } from '../../selectors/utils';

export default createSelector(
  hasUserSelector,
  localeSelector,
  jobsFooterSelector,
  eventsFooterSelector,
  newsFooterSelector,
  groupsFooterSelector,
  companiesFooterSelector,
  campusFooterSelector,
  coachesFooterSelector,
  (
    hasUser,
    locale,
    jobsFooter,
    eventsFooter,
    newsFooter,
    groupsFooter,
    companiesFooter,
    campusFooter,
    coachesFooter
  ) => {
    return hasUser
      ? []
      : [
          jobsFooter,
          eventsFooter,
          newsFooter,
          groupsFooter,
          companiesFooter,
          campusFooter,
          coachesFooter,
        ].map(localizedLink(locale));
  }
);
